import { useEffect, useState } from "react";
import GMTIcon from "../../../img/svg/gmtIcon";
import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "../../../firebase";
import { IVideo } from "../admin/home/adminHomeConfigs";
import { getURLParams } from "../../../utils/functions";
import BannersCase from "../../core/bannersCase";
import LoadingBalls from "../../core/loadingBalls";
import { Link } from "react-router-dom";
import WatchesGrid from "./watchesGrid";
import Ads from "./ads";
import BrandsGrid from "./brandsGrid";
import { useWatches } from "../../../context/watchProvider";
import { useNavigate } from "react-router-dom";
import SearchIcon from "../../../img/svg/searchIcon";


export default function Home({ isMobile, currentImage }: { isMobile: boolean, currentImage: string }) {

    const { getTop10Watches } = useWatches();
    const navigate = useNavigate();

    const [banners, setBanners] = useState<{ [key: string]: any }[]>([]);
    const [video, setVideo] = useState<IVideo | null>(null);
    const [loading, setLoading] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    // const [currentImage, setCurrentImage] = useState("");

    useEffect(() => {
        // getCurrentImage();
        getBanners();
        getVideo();
        getTop10Watches();
        // eslint-disable-next-line
    }, [])

    const getVideo = async () => {
        try {
            const docSnap = await getDocs(collection(db, "videos"));
            if (docSnap.empty) {
                setVideo(null);
                return null;
            }
            const docs = docSnap.docs.map(d => {
                return {
                    id: d.id,
                    link: d.data()?.link,
                    title: d.data()?.title,
                    description: d.data()?.description,
                    active: d.data()?.active,
                }
            })
            setVideo(docs.filter(d => d?.link)[0]);
        } catch (error) {
            console.log(error);
        }
    }

    // const getCurrentImage = async () => {
    //     try {
    //         const q = query(collection(db, "headerimages"), where("display", "==", true));
    //         const docsSnap = await getDocs(q);
    //         if (docsSnap.empty) {
    //             return null;
    //         }
    //         setCurrentImage(docsSnap.docs[0].data().url);
    //     } catch (error) {
    //         console.log(error);
    //         return null;
    //     }
    // }

    const getBanners = async () => {
        try {
            setLoading(true);
            const documents: { [key: string]: any }[] = [];
            const q = query(collection(db, "watches"), where("status", "==", "display"), where("isBanner", "==", true));
            const docs = await getDocs(q);
            if (docs.empty) {
                setBanners(documents);
                setLoading(false);
                return null;
            }
            docs.docs.forEach(b => {
                documents.push({
                    brand: b.data().brand,
                    model: b.data().model,
                    year: b.data().year,
                    price: b.data().price,
                    slug: b.data().slug,
                    imgUrl: b.data().images?.length ? b.data().images[0].cImgUrl : undefined,
                    order: b.data().order
                });
            })
            setBanners(documents.sort((a, b) => a.order - b.order));
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    }

    const handleSearch = (e: React.FormEvent) => {
        e.preventDefault();
        if (searchTerm.trim()) {
            navigate(`/watches?q=${searchTerm}`);
        }
    }

    return (
        <main className="mb-20 overflow-x-hidden">
            {/* Hero Section */}
            <div className="relative h-[400px] md:h-[500px] w-full bg-primary flex items-center justify-center overflow-hidden pt-20 md:pt-0">
                {
                    currentImage ?
                        <img
                            src={currentImage}
                            alt="Hero background"
                            className="absolute inset-0 w-full h-full object-cover opacity-60 scale-105"
                        />
                        : null
                }
                <div className="absolute inset-0 bg-gradient-to-b from-primary/80 via-primary/40 to-primary/90" />

                <div className="relative z-10 text-center px-4 animate-superfade w-full max-w-4xl pt-10 md:pt-0">
                    <form onSubmit={handleSearch} className="mb-6 md:mb-10 w-full max-w-lg mx-auto group">
                        <div className="relative flex items-center transition-all duration-300 group-focus-within:scale-105">
                            <input
                                type="text"
                                placeholder="Buscar por marca, modelo..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                className="w-full bg-white/10 backdrop-blur-md border border-white/20 px-6 py-4 pr-16 rounded-full text-white placeholder:text-white/50 focus:outline-none focus:ring-2 focus:ring-secondary/50 transition-all text-sm md:text-base shadow-2xl"
                            />
                            <button 
                                type="submit" 
                                className="absolute right-2 bg-secondary hover:bg-secondary-dark text-primary p-3 rounded-full transition-all duration-300 active:scale-90 hover:shadow-lg hover:shadow-secondary/20"
                            >
                                <SearchIcon fill="#111827" width="20px" />
                            </button>
                        </div>
                    </form>

                    <p className="text-secondary font-bold tracking-[0.3em] text-xs md:text-sm mb-4 uppercase">
                        Plataforma Exclusiva
                    </p>
                    <h1 className="font-outfit text-4xl md:text-7xl font-black text-white tracking-widest mb-6">
                        CLASSIFICADOS
                    </h1>
                    <div className="flex justify-center mb-8">
                        <div className="w-12 md:w-20 h-1 bg-secondary rounded-full" />
                    </div>
                    <div className="flex justify-center scale-75 md:scale-100">
                        <GMTIcon width="180px" fill="#fff" />
                    </div>
                </div>
            </div>

            {/* Featured Banners Section */}
            <section className="bg-surface py-24 relative px-4 border-y border-primary/5">
                <div className="max-w-7xl mx-auto">
                    <div className="flex flex-col items-center mb-16">
                        <p className="text-secondary font-bold tracking-[0.4em] text-[10px] uppercase mb-4">Seleção Especial</p>
                        <h2 className="text-3xl md:text-4xl font-black text-primary tracking-widest uppercase text-center mb-6">
                            Relógios em Destaque
                        </h2>
                        <div className="w-16 h-1 bg-secondary mb-8" />
                        <p className="text-mono text-center max-w-2xl mb-12 uppercase tracking-widest text-sm">
                            A plataforma de compra e venda do maior canal de relojoaria do país
                        </p>
                    </div>

                    {
                        loading ?
                            <div className="h-[365px] flex items-center justify-center">
                                <LoadingBalls />
                            </div>
                            : banners.length ?
                                <div className="space-y-12">
                                    <BannersCase banners={banners} isMobile={isMobile} />
                                    <div className="flex justify-center">
                                        <Link
                                            to={"/watches"}
                                            className="group relative px-10 py-4 bg-primary text-white font-bold tracking-widest text-sm overflow-hidden transition-all duration-300 hover:shadow-xl hover:shadow-secondary/20"
                                        >
                                            <span className="relative z-10">VER TODAS AS PEÇAS</span>
                                            <div className="absolute inset-0 bg-secondary translate-y-full group-hover:translate-y-0 transition-transform duration-300" />
                                        </Link>
                                    </div>
                                </div>
                                : <div className="mb-12"></div>
                    }
                </div>
            </section>

            <Ads isMobile={isMobile} />

            {/* YouTube Video Section */}
            {
                video && video.active ?
                    <section className="bg-moninho py-20 px-6 md:px-10">
                        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row gap-12 items-center">
                            <div className="lg:w-1/2 space-y-6 text-center lg:text-left">
                                <div className="w-12 h-1 bg-secondary mx-auto lg:mx-0" />
                                <h2 className="text-3xl md:text-5xl font-black text-primary leading-tight">
                                    {video?.title}
                                </h2>
                                <p className="text-lg text-mono leading-relaxed max-w-xl mx-auto lg:mx-0">
                                    {video?.description}
                                </p>
                                <div className="pt-4">
                                    <a
                                        href={video.link}
                                        target="_blank"
                                        rel="noreferrer"
                                        className="inline-flex items-center gap-3 text-secondary font-bold hover:gap-5 transition-all duration-300"
                                    >
                                        VER NO YOUTUBE <span className="text-xl">→</span>
                                    </a>
                                </div>
                            </div>
                            <div className="lg:w-1/2 w-full">
                                <div className="relative group rounded-3xl overflow-hidden shadow-2xl bg-black">
                                    <iframe
                                        className="w-full aspect-video"
                                        src={`https://www.youtube.com/embed/${getURLParams(video.link).v}`}
                                        title="YouTube video player"
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                        referrerPolicy="strict-origin-when-cross-origin"
                                        allowFullScreen>
                                    </iframe>
                                </div>
                            </div>
                        </div>
                    </section>
                    : null
            }

            {/* Brands Section */}
            <BrandsGrid isMobile={isMobile} />

            {/* Latest Arrivals */}
            <section className="py-24 px-4 bg-white">
                <div className="max-w-7xl mx-auto flex flex-col items-center">
                    <div className="flex flex-col items-center mb-16">
                        <p className="text-secondary font-bold tracking-[0.4em] text-[10px] uppercase mb-4">Novidades</p>
                        <h2 className="text-3xl md:text-4xl font-black text-primary tracking-widest uppercase text-center mb-6">
                            Últimos Anúncios
                        </h2>
                        <div className="w-16 h-1 bg-secondary" />
                    </div>
                </div>
                <WatchesGrid criter="date" />



                <div className="flex justify-center mt-12">
                    <Link
                        to={"/watches"}
                        className="group relative px-10 py-4 bg-primary text-white font-bold tracking-widest text-sm overflow-hidden transition-all duration-300 hover:border-secondary border border-transparent"
                    >
                        <span className="relative z-10 group-hover:text-secondary transition-colors">EXPLORAR CATÁLOGO</span>
                        <div className="absolute inset-0 bg-white translate-y-full group-hover:translate-y-0 transition-transform duration-300" />
                    </Link>
                </div>
            </section>

            <div className="bg-gradient-to-r from-transparent via-secondary/20 to-transparent h-[1px] w-full my-10" />
        </main>
    )
}
